import { render, staticRenderFns } from "./UnsplashSearch.vue?vue&type=template&id=a6b1bd32&scoped=true"
import script from "./UnsplashSearch.vue?vue&type=script&lang=js"
export * from "./UnsplashSearch.vue?vue&type=script&lang=js"
import style0 from "./UnsplashSearch.vue?vue&type=style&index=0&id=a6b1bd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1bd32",
  null
  
)

export default component.exports